define("shared/components/shared/post/secondary/activity/body", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@glimmer/component", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _component2, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.canUsePostActivityLog}}
    {{#if this.needsApproval}}
      <div class="cAP--approve__button">
        <span class="u--text--sm u--text--bold u--p__l__xs">{{t "approval.post-modal.banner.review_button"}}</span>
        {{#if this.needsUpgrade}}
          <Shared::Button::Upgrade
            @feature={{"approverRoles"}}
            @location="post modal activity log"
            @text={{t "shared_words.approve"}}
            @trialText={{t "shared_words.approve"}}
            @variant="proceed"
            class="u--p__xs u--m__l__auto qa--modal_approve_button"
          />
        {{else}}
          <Shared::Ui::Button
            @class="u--p__xs u--m__l__auto qa--modal_approve_button"
            @promise={{this.approvePost}}
            @text={{t "shared_words.approve"}}
            @variant="proceed"
          />
        {{/if}}
      </div>
    {{/if}}
    <div
      class={{concat-classes
        "o--modalBody--secondary cAP--modalBody--secondary cAP--list"
        (unless @formattedPostActivities.length "is--empty u--text--light")
      }}
      data-test-id="post-activity-body"
      {{perfect-scroll @scrollbarId}}
    >
      {{#if @formattedPostActivities.length}}
        <ul class="cAP--list qa--activity_modal_commentList">
          {{#each @formattedPostActivities as |formattedPostActivity|}}
            {{#if (eq formattedPostActivity.type "divider")}}
              {{! Date Divider}}
              <Shared::Post::Secondary::Activity::Divider @divider={{formattedPostActivity}} />
            {{else if (eq formattedPostActivity.type "comment")}}
              {{! Comments }}
              <Shared::Post::Secondary::Activity::Comment @comment={{formattedPostActivity}} />
            {{else if (eq formattedPostActivity.type "action")}}
              {{! Action }}
              <Shared::Post::Secondary::Activity::Action @action={{formattedPostActivity}} />
            {{/if}}
          {{/each}}
        </ul>
      {{else}}
        <div class="img--empty__conversations"></div>
        <span class="u--m__b__0 u--m__t__md">
          {{t "approval.secondary-modal.body.no_activity"}}
        </span>
      {{/if}}
    </div>
    {{#if this.showAddUsers}}
      <div class="cAP--modalBody--banner">
        <span>{{t "approval.secondary-modal.body.add_users_cta"}}</span>
        <Shared::Ui::Button
          @promise={{this.redirectToGroupMembers}}
          @text={{t "approval.secondary-modal.body.add_users"}}
          @variant="unstyled"
          aria-label={{t "approval.secondary-modal.body.add_users"}}
          class="u--p__0 u--text--hl"
        />
      </div>
    {{/if}}
  {{else}}
    <div class="o--modalBody--secondary cAP--modalBody--secondary">
      <div class="cAP--modalBody--upgrade">
        <p class="u--text--bold">{{t "approval.secondary-modal.upgrade.title"}}</p>
        <p class="u--m__0">{{t "approval.secondary-modal.upgrade.subtitle"}}</p>
  
        <hr class="u--m__tb" />
        <p>{{html-safe (t "approval.secondary-modal.upgrade.plan_includes")}}</p>
  
        <Shared::Button::Upgrade
          @feature="postActivity"
          @location="post activity secondary modal"
          class="u--p__lr o--btn--lg o--btn--block"
        />
      </div>
    </div>
  {{/if}}
  */
  {
    "id": "hTOJWb8E",
    "block": "[[[41,[30,0,[\"canUsePostActivityLog\"]],[[[41,[30,0,[\"needsApproval\"]],[[[1,\"    \"],[10,0],[14,0,\"cAP--approve__button\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--text--sm u--text--bold u--p__l__xs\"],[12],[1,[28,[35,1],[\"approval.post-modal.banner.review_button\"],null]],[13],[1,\"\\n\"],[41,[30,0,[\"needsUpgrade\"]],[[[1,\"        \"],[8,[39,2],[[24,0,\"u--p__xs u--m__l__auto qa--modal_approve_button\"]],[[\"@feature\",\"@location\",\"@text\",\"@trialText\",\"@variant\"],[\"approverRoles\",\"post modal activity log\",[28,[37,1],[\"shared_words.approve\"],null],[28,[37,1],[\"shared_words.approve\"],null],\"proceed\"]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,3],null,[[\"@class\",\"@promise\",\"@text\",\"@variant\"],[\"u--p__xs u--m__l__auto qa--modal_approve_button\",[30,0,[\"approvePost\"]],[28,[37,1],[\"shared_words.approve\"],null],\"proceed\"]],null],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[11,0],[16,0,[28,[37,4],[\"o--modalBody--secondary cAP--modalBody--secondary cAP--list\",[52,[51,[30,1,[\"length\"]]],\"is--empty u--text--light\"]],null]],[24,\"data-test-id\",\"post-activity-body\"],[4,[38,6],[[30,2]],null],[12],[1,\"\\n\"],[41,[30,1,[\"length\"]],[[[1,\"      \"],[10,\"ul\"],[14,0,\"cAP--list qa--activity_modal_commentList\"],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,1]],null]],null],null,[[[41,[28,[37,9],[[30,3,[\"type\"]],\"divider\"],null],[[[1,\"            \"],[8,[39,10],null,[[\"@divider\"],[[30,3]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,9],[[30,3,[\"type\"]],\"comment\"],null],[[[1,\"            \"],[8,[39,11],null,[[\"@comment\"],[[30,3]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,9],[[30,3,[\"type\"]],\"action\"],null],[[[1,\"            \"],[8,[39,12],null,[[\"@action\"],[[30,3]]],null],[1,\"\\n          \"]],[]],null]],[]]]],[]]]],[3]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"img--empty__conversations\"],[12],[13],[1,\"\\n      \"],[10,1],[14,0,\"u--m__b__0 u--m__t__md\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"approval.secondary-modal.body.no_activity\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[41,[30,0,[\"showAddUsers\"]],[[[1,\"    \"],[10,0],[14,0,\"cAP--modalBody--banner\"],[12],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,1],[\"approval.secondary-modal.body.add_users_cta\"],null]],[13],[1,\"\\n      \"],[8,[39,3],[[16,\"aria-label\",[28,[37,1],[\"approval.secondary-modal.body.add_users\"],null]],[24,0,\"u--p__0 u--text--hl\"]],[[\"@promise\",\"@text\",\"@variant\"],[[30,0,[\"redirectToGroupMembers\"]],[28,[37,1],[\"approval.secondary-modal.body.add_users\"],null],\"unstyled\"]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null]],[]],[[[1,\"  \"],[10,0],[14,0,\"o--modalBody--secondary cAP--modalBody--secondary\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"cAP--modalBody--upgrade\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"u--text--bold\"],[12],[1,[28,[35,1],[\"approval.secondary-modal.upgrade.title\"],null]],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--m__0\"],[12],[1,[28,[35,1],[\"approval.secondary-modal.upgrade.subtitle\"],null]],[13],[1,\"\\n\\n      \"],[10,\"hr\"],[14,0,\"u--m__tb\"],[12],[13],[1,\"\\n      \"],[10,2],[12],[1,[28,[35,13],[[28,[37,1],[\"approval.secondary-modal.upgrade.plan_includes\"],null]],null]],[13],[1,\"\\n\\n      \"],[8,[39,2],[[24,0,\"u--p__lr o--btn--lg o--btn--block\"]],[[\"@feature\",\"@location\"],[\"postActivity\",\"post activity secondary modal\"]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]],[\"@formattedPostActivities\",\"@scrollbarId\",\"formattedPostActivity\"],false,[\"if\",\"t\",\"shared/button/upgrade\",\"shared/ui/button\",\"concat-classes\",\"unless\",\"perfect-scroll\",\"each\",\"-track-array\",\"eq\",\"shared/post/secondary/activity/divider\",\"shared/post/secondary/activity/comment\",\"shared/post/secondary/activity/action\",\"html-safe\"]]",
    "moduleName": "shared/components/shared/post/secondary/activity/body.hbs",
    "isStrictMode": false
  });
  let BodyComponent = _exports.default = (_dec = (0, _service.service)('schedule/posts-pending-approval'), (_class = class BodyComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor3, this);
      _initializerDefineProperty(this, "errors", _descriptor4, this);
      _initializerDefineProperty(this, "intl", _descriptor5, this);
      _initializerDefineProperty(this, "postsPendingApproval", _descriptor6, this);
      _initializerDefineProperty(this, "router", _descriptor7, this);
      _initializerDefineProperty(this, "store", _descriptor8, this);
      _initializerDefineProperty(this, "userRole", _descriptor9, this);
      _defineProperty(this, "redirectToGroupMembers", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (this.args.hasUnsavedChanges) {
            const didConfirm = yield this.dialogManager.confirmation(this.intl.t('shared_phrases.close_warning'), {
              description: this.intl.t('post.unsaved_changes'),
              cancelButton: this.intl.t('shared_words.cancel'),
              confirmButton: this.intl.t('shared_words.leave')
            });
            if (!didConfirm) {
              return;
            }
          }
          this.router.transitionTo('account.groups.group.members', this.auth.currentGroup.id);
        }
      }), null, "redirectToGroupMembers", null));
      _defineProperty(this, "approvePost", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (!this.canUserApprove) {
            this.errors.log("User can't approve post");
            return;
          }
          if (this.args.post.get('hasDirtyAttributes')) {
            const didConfirm = yield this.dialogManager.confirmation(this.intl.t('approval.post-modal.banner.confirmation.title'), {
              description: this.intl.t('approval.post-modal.banner.confirmation.message'),
              confirmButton: this.intl.t('approval.post-modal.banner.confirmation.button'),
              cancelButton: this.intl.t('shared_words.cancel')
            });
            if (!didConfirm) {
              return;
            }
          }
          try {
            yield this.args.post.approve();
            this.postsPendingApproval.fetchCount.perform();
            this.alerts.success(this.intl.t('alerts.approval.post-modal.success.message'), {
              title: this.intl.t('alerts.approval.post-modal.success.title')
            });
          } catch (error) {
            this.alerts.warning(this.intl.t('alerts.generic_error_message'));
            this.errors.log('Approve Post Error', error);
          } finally {
            if (this.updatePostActivity) {
              yield this.store.query('post-activity', {
                post_id: this.args.post.id
              });
            }
          }
        }
      }), null, "approvePost", null));
    }
    get canUsePostActivityLog() {
      return Boolean(this.auth.currentAccount.canUsePostActivityLog);
    }
    get needsUpgrade() {
      return !this.auth.currentAccount.canApprovalFlow;
    }
    get canUserApprove() {
      return this.userRole.currentUser.isApprover;
    }
    get needsApproval() {
      return this.canUserApprove && Boolean(this.args.post.pendingApproval) && this.auth.currentAccount.rolloutExternalPostReview;
    }
    get showAddUsers() {
      return this.auth.currentUserModel.isAccountOwner && this.auth.currentGroup.nonContributorMemberCount === 1;
    }
    get updatePostActivity() {
      return Boolean(this.auth.currentAccount.canUsePostActivityLog);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "postsPendingApproval", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "userRole", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BodyComponent);
});